"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelColorThemes = exports.FontSizeOptions = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var b2c_theme_1 = require("../../Theme/b2c-theme");
var FontSizeOptions;
(function (FontSizeOptions) {
    FontSizeOptions["default"] = "default";
    FontSizeOptions["small"] = "small";
    FontSizeOptions["large"] = "large";
    FontSizeOptions["xLarge"] = "xLarge";
})(FontSizeOptions = exports.FontSizeOptions || (exports.FontSizeOptions = {}));
var LabelColorThemes;
(function (LabelColorThemes) {
    LabelColorThemes["success"] = "success";
    LabelColorThemes["danger"] = "danger";
    LabelColorThemes["error"] = "error";
    LabelColorThemes["mighty"] = "mighty";
})(LabelColorThemes = exports.LabelColorThemes || (exports.LabelColorThemes = {}));
var getThemeBackground = function (theme) {
    switch (theme) {
        case 'error':
            return b2c_theme_1.colors.warningAlert;
        case 'danger':
            return b2c_theme_1.colors.attentionAlert;
        case 'mighty':
            return b2c_theme_1.brandColors.mighty;
        default:
            return b2c_theme_1.colors.successAlert;
    }
};
var StatusLabelElement = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  text-align: center;\n  font-family: '", "';\n  background-color: ", ";\n  padding: ", ";\n  border-radius: ", ";\n"], ["\n  display: inline-block;\n  text-align: center;\n  font-family: '", "';\n  background-color: ", ";\n  padding: ", ";\n  border-radius: ", ";\n"])), function () { return b2c_theme_1.fonts.default; }, function (props) { return getThemeBackground(props.theme); }, function (props) {
    return props.extraPadding ? '2rem 4rem' : '0.9rem 1.2rem 0.7rem';
}, function (props) { return (props.extraPadding ? '4rem' : '2rem'); });
var Paragraph = styled_components_1.default.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: #ffffff;\n  margin: 0;\n  ", "\n"], ["\n  color: #ffffff;\n  margin: 0;\n  ", "\n"])), function (props) {
    switch (props.fontSize) {
        case 'small':
            return 'font-size: 1rem;';
        case 'large':
            return 'font-size: 1.4rem;';
        case 'xLarge':
            return 'font-size: 1.6rem;';
        default:
            return 'font-size: 1.2rem;';
    }
});
var StatusLabel = function (_a) {
    var className = _a.className, extraPadding = _a.extraPadding, fontSize = _a.fontSize, text = _a.text, theme = _a.theme;
    return (react_1.default.createElement(StatusLabelElement, { className: className, "data-testid": "status-label-container", extraPadding: extraPadding, theme: theme },
        react_1.default.createElement(Paragraph, { "data-testid": "status-label-text", fontSize: fontSize, dangerouslySetInnerHTML: { __html: text } })));
};
exports.default = StatusLabel;
var templateObject_1, templateObject_2;
//# sourceMappingURL=StatusLabel.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Labels/StatusLabel/StatusLabel.js
// module id = 1577
// module chunks = 1 5 15 18